function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { FETCH_ACTIVITY_SUCCESS, FETCH_SINGLE_TOPIC_SUCCESS, FETCH_TOPICS_SUCCESS, SEARCH_TOPICS_SUCCESS, SELECT_SEARCHED_TOPIC, SELECT_TOPIC, UPDATE_TOPIC_SUCCESS } from "../actions";
import initialState from "./initialState";
import { each, assign } from "lodash";
export default function topics() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.topics, action = arguments.length > 1 ? arguments[1] : void 0;
    var newTopics;
    var newTopic;
    switch(action.type){
        case FETCH_TOPICS_SUCCESS:
            {
                // 1st: hide everything
                newTopics = _objectSpread({}, state.allTopics);
                each(newTopics, function(topic) {
                    topic.__hidden = true;
                });
                // 2nd: update all other
                action.topics.forEach(function(topic) {
                    var topicID = topic.id;
                    if (topicID) {
                        newTopics[topicID] = assign(newTopics[topicID] || {
                            __hidden: false
                        }, topic);
                        newTopics[topicID] = _objectSpreadProps(_objectSpread({}, newTopics[topicID]), {
                            __hidden: false
                        });
                    }
                });
                return _objectSpreadProps(_objectSpread({}, state), {
                    allTopics: newTopics
                });
            }
        case FETCH_SINGLE_TOPIC_SUCCESS:
            {
                newTopics = _objectSpread({}, state.allTopics);
                newTopic = _objectSpreadProps(_objectSpread({}, action.topic), {
                    __hidden: false,
                    unread: 0
                });
                var topicID = action.topic.id;
                newTopics[topicID] = assign(newTopics[topicID] || {
                    __hidden: false
                }, newTopic);
                return _objectSpreadProps(_objectSpread({}, state), {
                    allTopics: newTopics
                });
            }
        case FETCH_ACTIVITY_SUCCESS:
            {
                newTopics = _objectSpread({}, state.allTopics);
                if (newTopics[action.topic.id] && action.topic.id) {
                    newTopics[action.topic.id] = _objectSpreadProps(_objectSpread({}, newTopics[action.topic.id]), {
                        last_activity_at: action.activity.updated_at
                    });
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    allTopics: newTopics
                });
            }
        case SELECT_SEARCHED_TOPIC:
            return _objectSpreadProps(_objectSpread({}, state), {
                currentSearch: {
                    searchId: action.topicId,
                    topic: action.topic,
                    app: action.app
                }
            });
        case SELECT_TOPIC:
            return _objectSpreadProps(_objectSpread({}, state), {
                currentTopicId: action.topic ? action.topic.id : null
            });
        case SEARCH_TOPICS_SUCCESS:
            return _objectSpreadProps(_objectSpread({}, state), {
                searchResult: {
                    topics: action.topics,
                    notes: action.notes
                }
            });
        case UPDATE_TOPIC_SUCCESS:
            {
                newTopics = _objectSpread({}, state.allTopics);
                if (newTopics[action.topicId]) {
                    newTopics[action.topicId].description = action.activity;
                }
                return _objectSpreadProps(_objectSpread({}, state), {
                    allTopics: newTopics
                });
            }
        default:
            return state;
    }
}
